import type React from 'react'
import type {
	ControllerConfig,
	HasValueSignature,
	InitialValueSignature,
	OptionType,
	ValueState,
} from '../../types'

import { Operators } from '@/shared/components/query-builder'

import { isObject } from '../../utils'
import FieldController from '../Controller'

export default class DateRangeController extends FieldController {
	constructor(config: ControllerConfig) {
		super(config)

		this.getInitialValue = config.getInitialValue || this.getInitialValue
		this.placeholder = config.placeholder || this.placeholder
		this.formatOptionLabel = config.formatOptionLabel
	}

	formatOptionLabel?: (option: OptionType) => React.ReactNode
	onMenuScrollToBottom?: () => void

	onMenuScrollToTop?: () => void

	placeholder?: string

	hasValue: HasValueSignature = ({ value }) =>
		Array.isArray(value) ? value.length > 0 : isObject(value)

	getInitialValue: InitialValueSignature = () => ({
		operation: Operators.DATE_BETWEEN,
		value: [],
	})

	formatLabel = ({ value }: ValueState<string[]>) => this.label
}
